export const initialState = {};

export const TYPES = {
  SAVE_MENU: "SAVE_MENU",
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SAVE_MENU: {
      const { jsonPath, jsonData } = action.menu;

      return {
        ...state,
        [`${jsonPath}`]: jsonData,
      };
    }

    default:
      return state;
  }
};

export default menuReducer;
